export default {
  nav: {
    home: "Home",
    about: "About",
    contact: "Contact"
  },
  languageSwitcher: {
    selectLanguage: "Select Language",
  },
  userMenu: {
    profile: "Profile",
    settings: "Settings",
    logout: "Logout"
  },
  home: {
    header: "Welcome to the Vue 3 I18n tutorial!",
    created_by: "This tutorial was brought to you by Lokalise.",
    welcome: "We are glad to have you here. Explore the internationalization features with Vue 3 and I18n."
  },
  about: {
    header: "About us"
  },
  login: {
    header: "Log in to your account",
    subheader: "Enter your credentials to access your account.",
    email: "Email Address",
    password: "Password",
    remember_me: "Remember Me",
    forgot_password: "Forgot your password?",
    login_button: "Log In",
    login_button_loading: "Logging In...",
    login_error: "Unable to log in. Please check your credentials and try again.",
    footer_sign_up_message: "Don't have an account?",
    footer_sign_up_link: "Sign Up now"
  },
  actions: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    update: "Update",
    ok: "OK"
  }
}
